import { render } from "./MovieList.vue?vue&type=template&id=27710d83&scoped=true"
import script from "./MovieList.vue?vue&type=script&lang=js"
export * from "./MovieList.vue?vue&type=script&lang=js"

import "./MovieList.vue?vue&type=style&index=0&id=27710d83&lang=postcss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27710d83"]])

export default __exports__